import * as React from "react";

import * as cn from "classnames";
import "./style/style.scss";
interface IPlayerArr {
  src: string;
  text: string;
}

interface IProps {
  vjsComponent: any;
  player: any;
  playerArr: IPlayerArr[];
}

interface IState {
  text: string;
}
export default class SwitcherList extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      text: ""
    };
  }

  public componentDidMount() {
    const { playerArr, player } = this.props;

    console.log("playerArr.src", `${playerArr[0].src}`);

    player.src(playerArr[0].src);
    this.setState({
      text: playerArr[0].text
    });
  }

  public onChangeSwitch = (e: any) => {
    const { index } = e.target.dataset;
    const { playerArr, player } = this.props;
    console.log("player", player);

    console.log("playerArr.src", `${playerArr[index].src}`);

    player.src(`${playerArr[index].src}`);
    this.setState({
      text: playerArr[index].text
    });
  };

  public render() {
    const { playerArr } = this.props;
    const { text } = this.state;
    return (
      <div className="vjs__switcher">
        <p>{text}</p>
        <ul className="vjs__switcher--container">
          {playerArr.map((item: IPlayerArr, key: number) => {
            return (
              <li
                className={cn("vjs__switcher--item", {
                  active: text === item.text
                })}
                key={key}
                data-index={key}
                onClick={this.onChangeSwitch}
              >
                {item.text}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/videoPlayerComtainer/switcher.tsx